/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { ComponentPropsWithoutRef, FC, useState } from "react";

type Props = ComponentPropsWithoutRef<"img"> & {
  fallbackSrc?: string;
};

const IMG: FC<Props> = ({ src, fallbackSrc, ...props }) => {
  const [source, setSource] = useState(src || fallbackSrc);
  return (
    <img
      src={source}
      alt={props.alt || "imagery"}
      onError={() => {
        if (fallbackSrc) {
          setSource(fallbackSrc);
        }
      }}
      {...props}
    />
  );
};

export default IMG;
